<template>
  <v-container fluid fill-height>
    <v-layout row align-center>
      <v-flex
        xs12
        class="display-2 font-weight-light text-xs-center">
        <div
          class="display-4 font-weight-light text-xs-center grey--text mb-5">
          <i class="fas fa-cogs"></i>
        </div>
        The page under development. Please come back latter.
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'development-placeholder'
}
</script>
